import { get } from "../../service/api";

const GetPoses = async () => {
  try {
    const response = await get(`/pos`);
    return response;
  } catch (error) {
    console.error("Error GetPoses:", error);
    throw error;
  }
};

export default GetPoses;
